<template>
    <div>
        <v-flex class="index" direction="column">
            <v-flex class="flex-shrink-0 header bg-dark p-4">
                <a aria-label="Ladder Home" class="text-white" href="https://joinladder.com">
                    <Wordmark class="wordmark" />
                </a>
                <div class="header-nav ml-auto">
                    <router-link aria-label="Ladder Coach" to="/coach"
                        >Coach</router-link
                    >
                    <router-link
                        aria-label="Ladder Club"
                        class="ml-3"
                        to="/club"
                        >Club</router-link
                    >
                </div>
            </v-flex>
            <transition mode="out-in" name="fade">
                <router-view class="flex-grow-1" />
            </transition>
        </v-flex>
        <ladder-footer :powered="false" class="footer border-top-0 bg-white">
            <template v-slot:content>
                <div class="flex-shrink-0 text-center text-dark footer-buttons">
                    <v-button
                        aria-label="Ladder Instagram"
                        class="mr-2"
                        href="https://instagram.com/joinladder"
                        target="_blank"
                        variant="light"
                    >
                        <fa-icon :icon="['fab', 'instagram']" />
                    </v-button>
                    <v-button
                        @click.prevent="showInfo = true"
                        aria-label="Ladder Legal Information"
                        class="mr-2"
                        variant="light"
                    >
                        <fa-icon :icon="['fas', 'info']" />
                    </v-button>
                    <v-button
                        @click.prevent="contactSupport"
                        aria-label="Ladder Chat Support"
                        variant="light"
                    >
                        <fa-icon :icon="['fas', 'question']" />
                    </v-button>
                </div>
            </template>
        </ladder-footer>
        <v-modal :cancel="false" :show.sync="showInfo">
            <div class="p-3">
                <a
                    aria-label="Ladder Privacy Policy"
                    block
                    class="mb-2"
                    href="https://joinladder.com/privacy"
                    variant="outline-primary"
                    >Privacy Policy</a
                >
                <br>
                <a
                    aria-label="Ladder Terms of Service"
                    block
                    href="https://joinladder.com/terms"
                    variant="outline-primary"
                    >Terms of Service</a
                >
            </div>
        </v-modal>
    </div>
</template>

<script>
import "@/utils/viewport.js";
import Wordmark from "@/components/Wordmark";
import LadderFooter from "@/components/LadderFooter";

export default {
    name: "IndexLayout",
    components: {
        Wordmark,
        LadderFooter,
        VModal: () => import("@/components/ui/VModal")
    },
    data() {
        return {
            showInfo: false
        };
    },
    updated() {
        window.scroll({ top: 0, left: 0, behavior: "auto" });
    },
    methods: {
        contactSupport() {
            require("@/services/Intercom.js");
            window.Intercom("show");
        }
    }
};
</script>

<style lang="scss" scoped>
.index {
    min-height: var(--vh);
}
.logo {
    height: 1.5rem;
    font-size: 1.5rem;
    line-height: 1.5rem;
}
.wordmark {
    height: 1rem;
    line-height: 1rem;
}
.header-nav a {
    font-size: 1.25rem;
}
.header a {
    color: $white;
    text-align: center;
    text-decoration: none;
    transition: all 300ms ease;
}
.header a:hover {
    opacity: 1;
    text-decoration: none;
    color: $warning !important;
}

.footer-buttons .btn {
    width: 2rem;
    height: 2rem;
    padding: 0px !important;
    line-height: 2rem;
    text-align: center;
    border-radius: 50% !important;
}
</style>
